import React, {useEffect} from 'react';
import store from '../redux/store'
import {
    Grid,
    Typography,
} from '@material-ui/core';
import {enqueueSnackbar} from '../redux/actions/snackbarActions';
import {errorMessage} from '../services/alertMessages';
import { getSnackbarLabels } from '../utils/languages';
import {LocalStorage} from '../utils/storage';
import {NotificationMessageService} from '../services/NotificationMessageService';


const FETCH_NOTIFICATION_INTERVAL_MS = 5 * 60 * 1000;
const NOTIFICATION_STORAGE_KEY = 'CACHE_notificationMessage';
const NOTIFICATION_LAST_REQUEST_KEY = 'CACHE_notificationLastRequestAt';

export default function NotificationBanner({open, handleClose = () => {}, receptionId, date}){
  const [bannerMessage, setBannerMessage] = React.useState('')
  const handleCloseRef = React.useRef(handleClose);

  useEffect(() => {
    handleCloseRef.current = handleClose;
  }, [handleClose]);

  useEffect(() => {
    const fetchNotification = () => {
      if (!localStorage.getItem('loginToken')) return;
      LocalStorage.set(NOTIFICATION_LAST_REQUEST_KEY, Date.now());

      NotificationMessageService.get()
        .then((response) => {
          const message = response?.data?.message || '';
          LocalStorage.set(NOTIFICATION_STORAGE_KEY, {message});
          setBannerMessage(message);
        })
        .catch(() => {
          LocalStorage.set(NOTIFICATION_STORAGE_KEY, {message: ''});
          store.dispatch(enqueueSnackbar(errorMessage(getSnackbarLabels.error.notification_message.get)));
          handleCloseRef.current();
        });
    };

    const notification = LocalStorage.get(NOTIFICATION_STORAGE_KEY, {message: ''});
    const lastRequestAt = LocalStorage.get(NOTIFICATION_LAST_REQUEST_KEY, 0);
    const now = Date.now();
    const minutesSinceLastRequest = now - lastRequestAt;
    setBannerMessage(notification.message || '');

    if (minutesSinceLastRequest >= FETCH_NOTIFICATION_INTERVAL_MS) {
      fetchNotification();
    }
  }, []);

  //En el caso de que haya un mensaje de notidicación se muestra el banner
  return (
          <React.Fragment>
              {bannerMessage !== '' &&
                          <Grid container style={{
                              backgroundColor: 'rgba(232,207,0,0.49)',
                              justifyContent: 'center',
                              padding: '10px',
                          }}>
                              <Grid item={12} alignContent={'center'}>
                                  <Typography variant="subtitle2" gutterBottom align="center">
                                      {bannerMessage}
                                  </Typography>
                              </Grid>
                          </Grid>

              }
    </React.Fragment>


  )
}
